var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_vm._t("before"),_vm._l((_vm.list),function(h){return _c('th',{key:h.label,class:{ summary: h.isSummary },domProps:{"innerHTML":_vm._s(_vm.replaceLfToBr(h.label))}})}),_vm._t("after")],2)}
var staticRenderFns = []

export { render, staticRenderFns }